
  import { defineComponent, PropType } from 'vue';

  import { TStorePaths } from '@/common/types/storePaths';

  import {
    STATISTICS_PORTAL_ACTIONS_NAME,
    STATISTICS_PORTAL_GETTERS_NAME,
    STATISTICS_PORTAL_MUTATIONS_NAME,
  } from '../../../store/statisticsPortal/name';
  import { TStatisticsPortalFilter } from '../../../types/statistics/statistics-portal';
  import StatisticsViewsCountByNavigationTab from '../StatisticsViewsCountByNavigationTab.vue';

  export default defineComponent({
    name: 'StatisticsPortalViewsCountByNavigationTab',
    components: {
      StatisticsViewsCountByNavigationTab,
    },
    props: {
      filter: {
        type: Object as PropType<TStatisticsPortalFilter>,
        required: true,
      },
    },
    data(): { firstStorePaths: TStorePaths; secondStorePaths: TStorePaths } {
      return {
        firstStorePaths: {
          action: STATISTICS_PORTAL_ACTIONS_NAME.getSectionsTable,
          mutation: STATISTICS_PORTAL_MUTATIONS_NAME.setSectionsTable,
          getter: STATISTICS_PORTAL_GETTERS_NAME.getSectionsTable,
        },
        secondStorePaths: {
          action: STATISTICS_PORTAL_ACTIONS_NAME.getPagesTable,
          mutation: STATISTICS_PORTAL_MUTATIONS_NAME.setPagesTable,
          getter: STATISTICS_PORTAL_GETTERS_NAME.getPagesTable,
        },
      };
    },
  });
